import "./emailsetting.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { getToken, getUser } from "../../services/authStore";
import { showSuccess, showError } from "../../components/ui/toast";

const API_URL = process.env.REACT_APP_API_URL;

export default function EmailSetting() {
  const token = getToken();
  const user = getUser();

  const [emailData, setEmailData] = useState({
    mail_driver: "",
    mail_host: "",
    mail_port: "",
    mail_username: "",
    mail_password: "",
    mail_encryption: "",
    mail_from_address: "",
    mail_from_name: "",
  });

  const [emailId, setEmailId] = useState(null);
  const [notifications, setNotifications] = useState([]);

  const fields = [
    { label: "Mail Driver", key: "mail_driver" },
    { label: "Mail Host", key: "mail_host" },
    { label: "Mail Port", key: "mail_port" },
    { label: "Mail Username", key: "mail_username" },
    { label: "Mail Password", key: "mail_password" },
    { label: "Mail Encryption", key: "mail_encryption" },
    { label: "Mail From Address", key: "mail_from_address" },
    { label: "Mail From Name", key: "mail_from_name" },
  ];

  useEffect(() => {
    const fetchEmailSetting = async () => {
      try {
        const res = await axios.get(
          `${API_URL}/settings/email/${user.company_id}`,
          { headers: { Authorization: `Bearer ${token}` } },
        );

        if (res.data) {
          setEmailData(res.data);
          setEmailId(res.data.id);
        }
      } catch (error) {
        setEmailId(null);
      }
    };

    const fetchNotifications = async () => {
      try {
        const res = await axios.get(
          `${API_URL}/settings/email-template/${user.company_id}`,
          { headers: { Authorization: `Bearer ${token}` } },
        );

        setNotifications(res.data || []);
      } catch (error) {
        console.error(error);
      }
    };

    if (token && user?.company_id) {
      fetchEmailSetting();
      fetchNotifications();
    }
  }, [token, user?.company_id]);

  // ==============================
  // HANDLE INPUT CHANGE
  // ==============================
  const handleChange = (key, value) => {
    setEmailData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  // ==============================
  // SAVE EMAIL SETTING
  // ==============================
  const handleSave = async () => {
    try {
      let response;

      if (emailId) {
        // UPDATE
        response = await axios.put(
          `${API_URL}/settings/email/${user.company_id}`,
          emailData,
          { headers: { Authorization: `Bearer ${token}` } },
        );
      } else {
        // CREATE
        response = await axios.post(
          `${API_URL}/settings/email/`,
          {
            ...emailData,
            company_id: user.company_id,
          },
          { headers: { Authorization: `Bearer ${token}` } },
        );
      }

      // 🔥 Load updated response data
      if (response.data) {
        setEmailData(response.data);
        setEmailId(response.data.id);
      }

      showSuccess("Email settings saved successfully");
    } catch (error) {
      console.error(error);
      showError(
        error?.response?.data?.message || "Failed to save email settings",
      );
    }
  };

  // ==============================
  // TOGGLE NOTIFICATION
  // ==============================
  // ==============================
  // TOGGLE NOTIFICATION
  // ==============================
  const handleToggle = async (item) => {
    try {
      const res = await axios.put(
        `${API_URL}/settings/email-template/${user.company_id}/${item.id}`,
        {
          name: item.name,
          slug: item.slug,
          active: !item.active,
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      // Update UI
      setNotifications((prev) =>
        prev.map((n) => (n.id === item.id ? res.data : n)),
      );

      // ✅ SUCCESS TOAST
      showSuccess(
        `${item.name} ${!item.active ? "enabled" : "disabled"} successfully`,
      );
    } catch (error) {
      console.error(error);

      // ❌ ERROR TOAST
      showError(
        error?.response?.data?.message ||
          "Something went wrong. Please try again.",
      );
    }
  };

  return (
    <div className="emailsetting-wrapper">
      <div className="emailsetting-container">
        <div className="emailsetting-header">
          <span className="emailsetting-title"></span>
        </div>

        <div className="emailsetting-group">
          <div className="email-grid">
            {fields.map((field, index) => (
              <div key={index} className="formgroup">
                <label>{field.label}</label>
                <input
                  type={field.key === "text"}
                  className="form-input"
                  value={emailData[field.key] || ""}
                  onChange={(e) => handleChange(field.key, e.target.value)}
                />
              </div>
            ))}
          </div>

          <div className="email-save-wrapper">
            <button className="email-save-btn" onClick={handleSave}>
              Save Changes
            </button>
          </div>

          {/* 🔥 EMAIL NOTIFICATION SECTION */}
          <div className="notification-section">
            <div className="notification-title">Email Notification</div>

            <div className="notification-grid">
              {notifications.map((item) => (
                <div key={item.id} className="notification-card">
                  <span>{item.name}</span>

                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={item.active}
                      onChange={() => handleToggle(item)}
                    />
                    <span className="slider"></span>
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
